const PUBLIC_SITE_ORIGIN = 'https://klaraview.se';

export const homeMetadata = {
  sv: {
    title: 'Fasadinspektion med drönare och AI-stöd',
    description: 'Fasadinspektion med drönare och AI-analys. KlaraView samlar bilder och observationer i spårbara underlag för underhåll och framtida uppföljning.',
  },
  en: {
    title: 'Drone façade inspection with AI support',
    description: 'Drone façade inspection and AI analysis. KlaraView connects images and observations in traceable documentation for maintenance and future follow-up.',
  },
};

export function publicSeoUrl(path: string): string {
  return `${PUBLIC_SITE_ORIGIN}${path}`;
}
